import { notification } from 'antd'
import capitalize from 'lodash/capitalize'

const notificationEvent = ({ message, type = 'info', duration = 5 }) => {
  notification[type]({
    message: capitalize(type),
    description: message,
    placement: 'bottomLeft',
    duration: duration
  })
}

export default notificationEvent
